<template>
  <div v-if="weekRelease.length > 0" class="">
    <table class="table">
      <thead>
        <tr>
          <th class="head" colspan="3">Releasing this Week</th>
        </tr>
      </thead>
      <tbody class="body">
        <template v-for="(item, j) in weekRelease">
          <template v-for="u in item.updates">
            <tr class="row-table" :key="u.show.id">
              <td
                width="25%"
                :class="{ claro: j % 2 == 0, oscuro: j % 2 == 1 }"
                class="text"
              >
                {{ u.releaseDate | date_single_updates }}
              </td>
              <td
                :class="{ claro: j % 2 == 0, oscuro: j % 2 == 1 }"
                class="value"
                width="55%"
              >
                <div class="table-item">
                  <div>
                    <figure class="table-item-img">
                      <img width="35px" :src="u.show.imageUrl" alt="" />
                    </figure>
                  </div>
                  <div>
                    <a
                      style="text-decoration: none"
                      :href="`/detail/${u.show.id}/${u.show.slug}`"
                    >
                      {{ u.show.title }}
                    </a>
                  </div>
                </div>
              </td>
              <td
                width="20%"
                :class="{
                  claro: j % 2 == 0,
                  oscuro: j % 2 == 1,
                  green: item.price == 'Free',
                }"
                class="value"
              >
                <figure class="table-item-platform">
                  <img
                    width="50px"
                    height="30px"
                    :src="item.imgPlatform"
                    :alt="item.platform"
                  />
                </figure>
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({}),
  computed: mapState(["weekRelease"]),
};
</script>

<style scoped>
.table {
  border-collapse: collapse;
  width: 100%;
}
.head {
  border-radius: 5px 5px 0 0;
}
.table > tbody > tr:last-child > td {
  border-radius: 0 0 0px 5px;
}
.table > tbody > tr:last-child > td:last-child {
  border-radius: 0 0 5px 0px;
}
.head {
  background-color: #ff5f5f;
  font-weight: 800;
  text-align: center;
  font-size: 1.2em;
  padding: 7px 0;
}

.headline-2 {
  font-size: 0.9rem;
  background-color: #1c2531;
  height: 40px;
}
.body > tr > td {
  height: 35px;
  font-size: 0.8rem;
  text-align: center;
  border-top: 1px solid #738092;
}
.title {
  text-align: center;
  font-weight: 600;
  border: 1px solid #738092;
  padding-top: 13px;
}

.value {
  border-left: 1px solid #738092;
  color: #cacaca;
}
.row-table:hover .value {
  color: #94c659;
  font-weight: bold;
}
.row-table:hover .text {
  color: white;
  font-weight: bold;
}

.green {
  font-weight: bold;
  color: #94c659 !important;
}
.claro {
  background-color: #375072;
}
.oscuro {
  background-color: #284060;
}

.divider {
  height: 60px;
}
.table-item {
  display: grid;
  grid-template-columns: 48px auto;
  align-items: center;
}

.table-item-img,
.table-item-platform {
  margin: 5px;
  padding: 0;
}
.table-item-platform > img {
  border-radius: 5px;

  object-fit: cover;
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.8em;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.7em;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.7em;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.6em;
  }
}

@media (max-width: 600px) {
  .text,
  .title,
  .footer,
  .value {
    font-size: 0.5em;
  }
}
</style>
